import { ActionContext } from 'vuex'
import { RootState } from '@ps/types/store'
import { drawRuler, removeRuler } from '@ps/store/workbench/stage/ruler'
import { StageState } from '@ps/types/workbench/stage.type'
import { Vector2d } from 'konva/lib/types'
import gameIframe from '@ps/bridge/iframe/iframe'

export default {
  drawKonvaRuler({ state, rootState }: ActionContext<StageState, RootState>): void {
    const sceneScale: number = rootState.workspace.game.device.scale
    console.log('sceneScale', sceneScale)
    let sceneWidth = 750
    const sceneOffset: Vector2d = state.sceneOffset
    // @ts-ignore
    if (gameIframe.UIRoot.ScaleAdapter && gameIframe.UIRoot.ScaleAdapter.referenceResolution && gameIframe.UIRoot.ScaleAdapter.referenceResolution.x) {
      // @ts-ignore
      const resolution = gameIframe.UIRoot.ScaleAdapter.referenceResolution
      sceneWidth = resolution.x < resolution.y ? resolution.x : resolution.y
    }
    if (state.showRuler) {
      drawRuler({
        space: 750 / sceneWidth * sceneScale * 5, // 因为游戏引擎默认世界缩放 0.5
        startCoord: sceneOffset,
        step: sceneScale < 0.8 ? 20 : 10
      })
    } else {
      removeRuler()
    }
  }
}
